import PropTypes from 'prop-types';
import React from 'react';
import { Button, ProgressBar } from '@blueprintjs/core';
import { withTranslation } from 'react-i18next';

// component dedicated to result progression bar and final results fetching when they are ready

class SpecialProgressBar extends React.PureComponent {

  state = {
    progression:0,
    nbParsedSents:0,
    totSents2parse:1,
    interruption:false,
    intervalId:null
  }

  componentDidMount() {
    const intervalId = setInterval(() => {
      this.fetchProgression();
    }, 1000);
    this.setState({intervalId:intervalId})
  }

  componentWillUnmount(){
    clearInterval(this.state.intervalId);
  }


  stopQuery= ()=> {
    const endpoint = '/fetch_progression.ajax.php';
    const data={ session_id: this.props.session_id, action:"stop" };
  
    fetch(
      process.env.REACT_APP_API_BASE + endpoint, {
        credentials: process.env.REACT_APP_CREDENTIALS,
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body: JSON.stringify(data),
      }
    )
    .then((res) => {
      if (res.status !== 200) {
        console.log(`Issue reaching ${endpoint}`);
        return;
      } else {
        this.setState({interruption:true});
        console.log(`Query of sessions ${this.props.session_id} has been stopped`);
      }
    })
  };

  fetchProgression= ()=> {
    const endpoint = '/fetch_progression.ajax.php';
    const data={ session_id: this.props.session_id, action:"fetch" };
    fetch(
      process.env.REACT_APP_API_BASE + endpoint, {
        credentials: process.env.REACT_APP_CREDENTIALS,
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body: JSON.stringify(data),
      }
    )
    .then((res) => {
      if (res.status !== 200) {
        console.log(`Issue reaching ${endpoint}`);
        return;
      }
      res.json().then((data) => {
        if (data.aborted && ! this.state.interruption) {
          clearInterval(this.state.intervalId);
        
          this.setState({ message:this.props.t('anErrorHasOccurred'), progression:1 });
        }
        else if (data.complete && ! this.state.complete) {
            clearInterval(this.state.intervalId);

            //console.log("clearInterval");
            this.setState({ message:this.props.t('loadingResults'), complete:true, progression:1 });
            const endpoint = this.props.alr ? 
                              '/sessions/'+this.props.session_id+"/output.alr.json":
                              '/sessions/'+this.props.session_id+"/output.json";
            //console.log("EndPoint: "+process.env.REACT_APP_API_BASE + endpoint + '?' + queryParams);
            fetch(
                process.env.REACT_APP_API_BASE + endpoint , {
                    credentials: "omit",
                    headers: { 'Content-Type': 'application/json' },
                    method: 'GET',
                }
            )
            .then((data) => {
                if (res.status !== 200) {
                    console.log(`Issue reaching ${endpoint}`);
                    return;
                } 
                data.json().then((results) => {
                    this.props.addResults(results);
                });
            });
        } else if (data.metadata) {
            this.setState({ 
                message:this.props.t('loadingResults'),
            });
        } else if (data.computing) {
          this.setState({ 
              message:this.props.t('computingStatistics'),
          });
        } else if (data.nbParsedSents) {
            const message=data.nbParsedSents>0?
                data.nbParsedSents.toString()+"/"+
                data.totSents2parse.toString()+" - "+ 
                this.props.t('foundSentsColon')+" "+
                data.nbFoundSents.toString():
                this.props.t('initialization');
            this.setState({ 
                message:message,
                progression:data.totSents2parse>0? (data.nbParsedSents/data.totSents2parse):0
            });
            //console.log(data.totSents2parse>0 ? (data.nbParsedSents/data.totSents2parse):0);
        } else if (this.state.interruption){
            this.setState({ 
                message:this.props.t('Interruption')
            });
        } 
        this.setState({ selectedResults: null });
      })
    })
  };


  render() {

    return  <center>
                <Button icon="stop" onClick={this.stopQuery}>Stop</Button>
                <br/><br/>
                <ProgressBar intent="Success" value={this.state.progression}/>
                <br/><br/>
                <p>{this.state.message}</p>
            </center>
  }
}

SpecialProgressBar.propTypes = {
    session_id: PropTypes.string,
    addResults: PropTypes.func,
    alr: PropTypes.bool,
};
      
export default withTranslation()(SpecialProgressBar);
      